<template>
	<view>
		<view class="cu-list grid col-3 no-border">
			<view class="cu-item">
				<view class="text-price text-xl">
					99.00
				</view>
				<text>昨日分红</text>
			</view>
			<view class="cu-item">
				<view class="text-price text-xl">
					99.00
				</view>
				<text>7日分红总计</text>
			</view>
			<view class="cu-item">
				<view class="text-price text-xl">
					99.00
				</view>
				<text>月分红总计</text>
			</view>
		</view>
		<view class="bg-white margin-sm padding">
			<view class="flex flex-wrap align-center text-center" style="width: 500rpx;margin: auto;">
				<view class="flex-sub" @click="tabSelect(0)">
					<view class="btn1" :class="TabCur==0?'active':''">昨日分红</view>
				</view>
				<view class="flex-sub" @click="tabSelect(1)">
					<view class="btn2" :class="TabCur==1?'active':''">7日分红</view>
				</view>
				<view class="flex-sub" @click="tabSelect(2)">
					<view class="btn3" :class="TabCur==2?'active':''">月分红</view>
				</view>
			</view>
			 
			<view class="margin-top">
			     <canvas @tap="tapLine($event,'canvasLineA')" canvas-id="canvasLineA" id="canvasLineA" class="charts"></canvas>
			</view>
		</view>
	</view>
</template>

<script>
	import uCharts from '@/pages2/u-charts/u-charts.min.js';
	var _self;
	var canvaLineA=null;
	var mycanvas=[];
	export default {
		data() {
			return {
				pixelRatio: 1,
				cWidth:'',
				cHeight:'',
				TabCur:1
			};
		},
		components: {
			
		},
		onLoad() {
			_self = this;
			this.cWidth=uni.upx2px(650);
			this.cHeight=uni.upx2px(500);
			this.zhexiantu("canvasLineA",[]);
		},
		methods: {
			/***** 基本柱形图start ******/
			zhexiantu(id,data){
				let LineA={
					categories: ['10-1','10-2','10-3','10-4','10-5','10-6','10-7'],
					series: [{
						name: "分红金额",
						color:'#e2231a',
						data: [54.77,62,56,78,35,68,85]
					}],
				};
				 
				this.showLineA(id,LineA);
			},
			tapLine(e,id){
				canvaLineA.showToolTip(e)
			},
			showLineA(canvasId,chartData){
				canvaLineA=new uCharts({
					$this:_self,
					canvasId: canvasId,
					type:'column',
					legend:true,
					fontSize:12,
					background:'#FFFFFF',
					pixelRatio:_self.pixelRatio,
					animation:true,
					categories: chartData.categories,
					series: chartData.series,
					xAxis:{
						disableGrid:true,
					},
				    yAxis:{
						disabled:true
					},
				    dataLabel:true,
				    width: _self.cWidth*_self.pixelRatio,
				    height: _self.cHeight*_self.pixelRatio,
					legend:{show: false},
					padding:[15,15,0,15],
					extra:{
				        column:{
				            type:'group',
							width: _self.cWidth*_self.pixelRatio*0.45/chartData.categories.length,
						}
					}
				});
				return;
			},
			/***** 基本柱形图end ******/
			tabSelect(e) {
				this.TabCur = e;
			} 
		}
	}
	
</script>

<style>
	@import '/pages2/common/main.css';
	@import '/pages2/common/icon.css';
	.btn1,.btn2,.btn3{
		border:1rpx solid #e2231a;
		padding:10rpx 0;
		color:#666;
	}
	.btn1{
		border-radius: 100rpx 0 0 100rpx;
	}
	.btn3{
		border-radius: 0 100rpx 100rpx 0;
	}
	.btn1.active,.btn2.active,.btn3.active{
		background: #e2231a;
		color: #fff;
	}
	.charts{width:100%; height:500upx;background-color:#FFFFFF;} 
</style>
